// Catalogo storico: gli ID Yamamoto mantengono sempre il significato originale.
const YAMAMOTO_CATALOG = [
  {
    id: "ossa-cardio",
    label: "Ossa & Sistema Cardiovascolare",
    items: [
      {
        id: "vitamina-k2-d3",
        name: "Vitamina K2 + D3 New Formula",
        detail: "60 compresse · supporto ossa e sistema cardiovascolare",
      },
      {
        id: "magnesium-citrate",
        name: "Magnesium CITRATE",
        detail: "90 compresse · supporto muscolare e osseo",
      },
      {
        id: "omega-3-ifos",
        name: "Omega-3 IFOS",
        detail: "60 softgels · supporto cardiovascolare",
      },
      {
        id: "omega-3-ifos-240",
        name: "Essential Omega-3 IFOS",
        detail: "240 softgel · scorta EPA/DHA",
      },
      {
        id: "omega-vegetale",
        name: "Omega Vegetale Ahiflower",
        detail: "60 softgels · fonte vegetale di omega",
      },
      {
        id: "coenzima-q10",
        name: "Coenzima Q10",
        detail: "60 capsule · energia cellulare",
      },
    ],
  },
  {
    id: "digestione-sonno-benessere",
    label: "Digestione, Sonno & Benessere",
    items: [
      { id: "levoris", name: "Levoris", detail: "30 capsule · probiotico e prebiotico" },
      { id: "enzymasic", name: "Enzymasic", detail: "30 capsule · enzimi digestivi" },
      { id: "inteflor", name: "Inteflor", detail: "30 capsule · sinergia fermenti e prebiotici" },
      { id: "melatovil", name: "Melatovil", detail: "20 ml · melatonina in gocce" },
      { id: "bromelina", name: "Bromelina", detail: "30 compresse · estratto di ananas" },
      {
        id: "saccharomyces-boulardii",
        name: "Saccharomyces Boulardii Lynside Pro SCB",
        detail: "30 capsule · equilibrio intestinale",
      },
      {
        id: "lactobacillus-reuteri",
        name: "Lactobacillus Reuteri",
        detail: "30 compresse · flora batterica",
      },
      {
        id: "bacillus-coagulans",
        name: "Bacillus Coagulans Lynside Pro SCB",
        detail: "12 stick · supporto microbiota",
      },
      { id: "lattasi", name: "Lattasi", detail: "30 capsule · digestione del lattosio" },
    ],
  },
  {
    id: "circolazione",
    label: "Benessere & Circolazione",
    items: [
      { id: "diuricell", name: "Diuricell", detail: "1000 ml / 20 stick · drenante" },
      {
        id: "diuricell-stick",
        name: "Diuricell Stick",
        detail: "20 stick da 4 g · drenante pronto uso",
      },
      { id: "microcircolo", name: "Microcircolo New Formula", detail: "30 compresse · supporto gambe" },
      { id: "vasomil", name: "Vasomil", detail: "30 bustine · supporto flusso venoso" },
      { id: "tarassaco", name: "Tarassaco", detail: "100 ml · depurazione e drenaggio" },
      { id: "cranberry", name: "Cranberry", detail: "30 compresse · benessere vie urinarie" },
    ],
  },
  {
    id: "energia-equilibrio",
    label: "Stress, Energia & Equilibrio",
    items: [
      { id: "ashwagandha", name: "Ashwagandha KSM-66", detail: "60 compresse · adattogeno" },
      { id: "energan", name: "Energan", detail: "700 g · blend carboidrati e minerali" },
      { id: "tirosina", name: "Tirosina", detail: "30 compresse · supporto focus" },
      { id: "caffeine-tabs", name: "Caffeine TABS", detail: "100 compresse · energia e focus" },
      { id: "sali-minerali", name: "Sali Minerali", detail: "30 bustine da 5 g · reidratazione" },
    ],
  },
  {
    id: "performance",
    label: "Performance & Recupero",
    items: [
      { id: "iso-fuji", name: "Iso-FUJI Volactive", detail: "700 g / 1200 g · proteina isolata" },
      { id: "iso-fuji-plus", name: "Iso-FUJI Plus", detail: "proteina isolata arricchita" },
      { id: "endopro", name: "EndoPRO", detail: "500 g · proteina del siero" },
      { id: "hydrocarn", name: "HydroCARN HydroBeef+", detail: "700 g · proteina di manzo idrolizzata" },
      { id: "oryx-powder", name: "Oryx Powder", detail: "500 g · blend proteico avanzato" },
      { id: "emperor-mass", name: "Emperor Mass", detail: "gainer · aumento massa" },
      { id: "essential-amino", name: "Essential AMINO", detail: "600 compresse · amminoacidi essenziali" },
      { id: "bcaa-411", name: "BCAA 4:1:1", detail: "200 compresse · rapporto 4:1:1" },
      { id: "bcaa-811", name: "BCAA 8:1:1", detail: "200 compresse · rapporto 8:1:1" },
      { id: "bcaa-pro-kyowa", name: "BCAA PRO Kyowa", detail: "300 compresse · materie prime Kyowa" },
      { id: "bcaa-powder-classic", name: "BCAA POWDER", detail: "300 g · formula classica" },
      { id: "bcaa-powder", name: "BCAA POWDER 8:1:1", detail: "300 g · ramificati alto dosaggio" },
      { id: "glutamine-pro", name: "Glutamine Pro", detail: "200 compresse · recupero" },
      { id: "arginine-pro", name: "Arginine Pro", detail: "240 tavolette · ossido nitrico" },
      {
        id: "acetyl-l-carnitine",
        name: "Acetyl L-Carnitine",
        detail: "1000 mg 120 capsule · ossidazione dei grassi",
      },
      { id: "glycobol", name: "GlycoBol Performance Cluster Dextrin", detail: "700 g · intra-workout" },
      { id: "creatinepro", name: "CreatinePRO Creapure", detail: "150 compresse / 500 g · creatina" },
      { id: "crea-powder", name: "Crea Powder", detail: "creatina monoidrato in polvere" },
      { id: "dark-katana", name: "Dark Katana", detail: "pre-workout ad alto stimolo" },
      { id: "sayan-fuel-stim", name: "Sayan Fuel STIM", detail: "pre-workout stimolante" },
      { id: "infusion-elite", name: "Infusion Elite", detail: "intra-workout bilanciato" },
    ],
  },
  {
    id: "beauty-pelle",
    label: "Beauty & Pelle",
    items: [
      { id: "acido-ialuronico", name: "Acido ialuronico Pure Skin Beauty", detail: "60 compresse · idratazione" },
      { id: "collagene-verisol", name: "Collagene Idrolizzato Verisol", detail: "30 bustine da 5 g · supporto pelle" },
    ],
  },
  {
    id: "immunitario",
    label: "Supporto Immunitario & Multivitaminico",
    items: [
      { id: "vitamin-c", name: "Vitamin C 1000", detail: "90 compresse · antiossidante" },
      { id: "multipro", name: "MultiPRO", detail: "80 compresse · multivitaminico" },
      { id: "acido-lipoico", name: "Acido Lipoico", detail: "60 capsule · supporto antiossidante" },
      { id: "astaxantina", name: "Astaxantina AstaZine", detail: "30 capsule · antiossidante carotenoide" },
      { id: "pappa-reale", name: "Pappa Reale", detail: "30 capsule · sostegno del tono" },
      { id: "colina-inositolo", name: "Colina e Inositolo", detail: "60 capsule · metabolismo epatico" },
    ],
  },
  {
    id: "snack-food",
    label: "Snack & Alimentazione",
    items: [
      { id: "endopro-bar", name: "EndoPRO BAR", detail: "1 barretta da 50 g" },
      { id: "endopro-bar-box", name: "EndoPRO BAR (box)", detail: "20 barrette da 50 g" },
      { id: "performancepro-bar", name: "PerformancePRO Bar", detail: "1 barretta da 60 g" },
      { id: "pancake", name: "Pancake", detail: "700 g · preparato proteico" },
      { id: "oat-flour", name: "Oat Flour", detail: "1000 g · farina di avena" },
    ],
  },
];

export const VITASTRONG_BUNDLES = Object.freeze([
  {
    "id": "vitastrong:morning-energy",
    "title": "Morning Energy",
    "products": [
      "Brainstrong",
      "Multivitaminico",
      "Magnesio e Potassio"
    ],
    "priceCents": 3327,
    "currency": "EUR",
    "purchaseUrl": "https://vitastrong.it/amb/morning-energy"
  },
  {
    "id": "vitastrong:training-performance",
    "title": "Training Performance",
    "products": [
      "EAA PRO",
      "Magnesio e Potassio"
    ],
    "priceCents": 2968,
    "currency": "EUR",
    "purchaseUrl": "https://vitastrong.it/amb/training-performance"
  },
  {
    "id": "vitastrong:woman-40",
    "title": "Woman 40+",
    "products": [
      "Glucosamina+",
      "Vitamin D3"
    ],
    "priceCents": 3238,
    "currency": "EUR",
    "purchaseUrl": "https://vitastrong.it/amb/woman-40"
  },
  {
    "id": "vitastrong:woman-40-2",
    "title": "Woman 40+ 2",
    "products": [
      "Glucosamina",
      "Bromelina"
    ],
    "priceCents": 3399,
    "currency": "EUR",
    "purchaseUrl": "https://vitastrong.it/amb/woman-40-2"
  },
  {
    "id": "vitastrong:body-composition",
    "title": "Body Composition",
    "products": [
      "CREATINA CREA STRONG DA 120CP",
      "EAA PRO"
    ],
    "priceCents": 3508,
    "currency": "EUR",
    "purchaseUrl": "https://vitastrong.it/amb/body-composition"
  },
  {
    "id": "vitastrong:body-composition2",
    "title": "Body Composition 2",
    "products": [
      "CREATINA CREA STRONG DA 120CP",
      "BCAA 4:1:1",
      "Magnesio e Potassio"
    ],
    "priceCents": 3327,
    "currency": "EUR",
    "purchaseUrl": "https://vitastrong.it/amb/body-composition2"
  },
  {
    "id": "vitastrong:metabolic-support",
    "title": "Metabolic Support",
    "products": [
      "Acido Alfa Lipoico 650",
      "Bromelina"
    ],
    "priceCents": 3598,
    "currency": "EUR",
    "purchaseUrl": "https://vitastrong.it/amb/metabolic-support"
  },
  {
    "id": "vitastrong:daily-bioenergy",
    "title": "Daily Bioenergy",
    "products": [
      "Multivitaminico",
      "Omega 3"
    ],
    "priceCents": 3058,
    "currency": "EUR",
    "purchaseUrl": "https://vitastrong.it/amb/daily-bioenergy"
  },
  {
    "id": "vitastrong:daily-snack",
    "title": "Daily Snack",
    "products": [
      "2 scatole Crunchy: Cioccolato e Cocco"
    ],
    "priceCents": 4498,
    "currency": "EUR",
    "purchaseUrl": "https://vitastrong.it/amb/daily-snack"
  },
  {
    "id": "vitastrong:night-recovery",
    "title": "Night Recovery",
    "products": [
      "Pack Sonno & Stress"
    ],
    "priceCents": 4767,
    "currency": "EUR",
    "purchaseUrl": "https://vitastrong.it/amb/night-recovery"
  },
  {
    "id": "vitastrong:microcircolo",
    "title": "Microcircolo",
    "products": [
      "Diosmin PRO (a base di centella)",
      "Bromelina"
    ],
    "priceCents": 2698,
    "currency": "EUR",
    "purchaseUrl": "https://vitastrong.it/amb/microcircolo"
  },
  {
    "id": "vitastrong:skin",
    "title": "Skin",
    "products": [
      "Collagene idrolizzato puro in polvere",
      "Magnesio e Potassio"
    ],
    "priceCents": 3238,
    "currency": "EUR",
    "purchaseUrl": "https://vitastrong.it/amb/skin"
  },
  {
    "id": "vitastrong:gonfiore",
    "title": "Gonfiore",
    "products": [
      "Probiotici",
      "Bromelina",
      "Enzimi digestivi"
    ],
    "priceCents": 2877,
    "currency": "EUR",
    "purchaseUrl": "https://vitastrong.it/amb/gonfiore"
  },
  {
    "id": "vitastrong:powerfood",
    "title": "Powerfood",
    "products": [
      "1 scatola di barrette Crunchy Choco Brownies",
      "Crema di arachidi Crunchy",
      "Farina istantanea d’avena naturale"
    ],
    "priceCents": 4047,
    "currency": "EUR",
    "purchaseUrl": "https://vitastrong.it/amb/powerfood"
  }
].map((bundle) => Object.freeze({ ...bundle, products: Object.freeze(bundle.products) })));

const bundleMap = new Map(VITASTRONG_BUNDLES.map((bundle) => [bundle.id, bundle]));
const legacyLabels = new Map(YAMAMOTO_CATALOG.flatMap((category) => category.items.map((item) => [item.id, item.name])));
const legacyPlans = { antiage: 'Antiage', rinforzante: 'Rinforzante', rilassante: 'Rilassante', riequilibrante: 'Riequilibrante', energizzante: 'Energizzante', depurativo: 'Depurativo' };
export const INTEGRATION_FIELDS = Object.freeze(['integrazioneProducts', 'pianoIntegrazione', 'integrazioneAssignment', 'integrazioneHistory']);

export function getLegacyIntegrationLabels(entry) {
  const labels = Array.isArray(entry?.integrazioneProducts)
    ? entry.integrazioneProducts.filter(Boolean).map((id) => legacyLabels.get(id) || String(id))
    : [];
  const plan = String(entry?.pianoIntegrazione || '').trim();
  if (plan && plan !== 'nointegrazione') labels.push(legacyPlans[plan] || plan);
  return labels;
}

export function hasLegacyIntegration(entry) {
  const plan = String(entry?.pianoIntegrazione || '').trim();
  return !!(Array.isArray(entry?.integrazioneProducts) && entry.integrazioneProducts.length) ||
    !!(plan && plan !== 'nointegrazione');
}

export function getVitastrongAssignment(entry) {
  return entry?.integrazioneAssignment?.partner === 'vitastrong' ? entry.integrazioneAssignment : null;
}

// Read both historical single-bundle snapshots and new multi-bundle assignments.
export function getVitastrongBundles(entry) {
  const assignment = getVitastrongAssignment(entry);
  if (!assignment) return [];
  return Array.isArray(assignment.bundles) ? assignment.bundles : assignment.bundleId ? [assignment] : [];
}

export function getIntegrationLabel(entry) {
  if (hasLegacyIntegration(entry)) return 'Integrazione storica';
  const assignment = getVitastrongAssignment(entry);
  if (assignment?.bundles?.length > 1) return `${assignment.bundles.length} bundle Vitastrong`;
  if (assignment) return assignment.title || 'Bundle Vitastrong';
  if (entry?.integrazioneAssignment) return 'Integrazione assegnata';
  return 'Aggiungi integrazione';
}

export function getIntegrationSummary(entry) {
  if (hasLegacyIntegration(entry)) {
    const labels = getLegacyIntegrationLabels(entry);
    return labels.slice(0, 3).join(', ') + (labels.length > 3 ? ' +' + (labels.length - 3) : '');
  }
  const assignment = getVitastrongAssignment(entry);
  if (assignment?.bundles?.length > 1) {
    const titles = assignment.bundles.map((bundle) => bundle.title);
    return titles.slice(0, 2).join(', ') + (titles.length > 2 ? ` +${titles.length - 2}` : '');
  }
  return assignment ? 'Vitastrong' : '';
}

// Firestore map keys can arrive in different orders across reads. Sort object
// keys recursively while preserving array order, values and JSON conversions.
export function serializeIntegrationValue(value) {
  return JSON.stringify(value, (_key, item) => (
    item && typeof item === 'object' && !Array.isArray(item)
      ? Object.fromEntries(Object.keys(item).sort().map((key) => [key, item[key]]))
      : item
  ));
}

export function getIntegrationSignature(entry) {
  return serializeIntegrationValue(INTEGRATION_FIELDS.map((key) => entry?.[key] ?? null));
}

// A full-array save must not replace the current integration with a stale UI snapshot.
export function preserveIntegrationFields(candidate, authoritative) {
  const protectedEntry = { ...candidate };
  for (const key of INTEGRATION_FIELDS) {
    delete protectedEntry[key];
    if (authoritative && Object.prototype.hasOwnProperty.call(authoritative, key)) {
      protectedEntry[key] = authoritative[key];
    }
  }
  return protectedEntry;
}

function equalValues(a, b) {
  return JSON.stringify(a) === JSON.stringify(b);
}

export function mergeProtectedProgramLists(current = [], incoming = [], baseEntries) {
  const result = current.map((entry) => ({ ...entry }));
  const index = new Map(result.map((entry, i) => [entry.id, i]).filter(([id]) => id));
  const baseMap = new Map((baseEntries || []).filter((entry) => entry.id).map((entry) => [entry.id, entry]));
  incoming.forEach((entry) => {
    if (!entry?.id) throw new Error('Alimentazione senza identificativo. Ricarica la pagina.');
    const position = index.get(entry.id);
    if (position === undefined) {
      // Do not resurrect an entry deleted since this editor loaded it.
      if (baseMap.has(entry.id)) return;
      index.set(entry.id, result.length);
      result.push(preserveIntegrationFields(entry, null));
      return;
    }
    const before = baseMap.get(entry.id);
    const patch = {};
    Object.entries(entry).forEach(([key, value]) => {
      if (INTEGRATION_FIELDS.includes(key) || value === undefined) return;
      if (!before || !equalValues(before[key], value)) patch[key] = value;
    });
    result[position] = preserveIntegrationFields({ ...result[position], ...patch }, result[position]);
  });
  return result;
}

const euroFormatter = new Intl.NumberFormat('it-IT', { style: 'currency', currency: 'EUR' });
export function formatIntegrationPrice(cents, currency = 'EUR') {
  if (!Number.isFinite(cents)) return '';
  return currency === 'EUR' ? euroFormatter.format(cents / 100)
    : new Intl.NumberFormat('it-IT', { style: 'currency', currency }).format(cents / 100);
}

function normalizeBundleIds(selection, { allowEmpty = false } = {}) {
  const ids = [...new Set(Array.isArray(selection) ? selection : [selection])];
  if ((!allowEmpty && !ids.length) || ids.some((id) => !bundleMap.has(id))) {
    throw new Error('Seleziona almeno un bundle Vitastrong valido.');
  }
  // Stable catalog ordering: clicking the same selection in a different order is a no-op.
  return VITASTRONG_BUNDLES.filter((bundle) => ids.includes(bundle.id)).map((bundle) => bundle.id);
}

function bundleSnapshot(bundle) {
  return {
    bundleId: bundle.id,
    title: bundle.title,
    products: [...bundle.products],
    priceCents: bundle.priceCents,
    currency: bundle.currency,
    purchaseUrl: bundle.purchaseUrl,
  };
}

export function createVitastrongAssignment(selection, actorId, now, previous) {
  const ids = normalizeBundleIds(selection);
  const previousBundles = getVitastrongBundles({ integrazioneAssignment: previous });
  const snapshots = ids.map((id) => {
    const existing = previousBundles.find((bundle) => bundle.bundleId === id);
    // A retained bundle keeps the exact details originally assigned, not a later catalog price.
    return existing ? bundleSnapshot({ ...existing, id }) : bundleSnapshot(bundleMap.get(id));
  });
  const metadata = {
    partner: 'vitastrong',
    catalogVersion: 1,
    assignedAt: now,
    assignedBy: actorId,
    revision: Number(previous?.revision || 0) + 1,
  };
  if (snapshots.length === 1) return { ...metadata, ...snapshots[0] };
  return {
    ...metadata,
    schemaVersion: 2,
    bundles: snapshots,
    title: snapshots.map((bundle) => bundle.title).join(' + '),
    products: snapshots.flatMap((bundle) => bundle.products),
    priceCents: snapshots.reduce((sum, bundle) => sum + bundle.priceCents, 0),
    currency: 'EUR',
  };
}

export function applyVitastrongAssignment(entry, selection, actorId, now, expectedSignature) {
  if (hasLegacyIntegration(entry)) throw new Error('Questa alimentazione ha già un’integrazione storica, che resta conservata.');
  if (entry.integrazioneAssignment && !getVitastrongAssignment(entry)) throw new Error('Integrazione già assegnata: non può essere sostituita.');
  if (getIntegrationSignature(entry) !== expectedSignature) throw new Error('L’integrazione è cambiata. Chiudi e riapri il selettore per vedere i dati aggiornati.');
  const ids = normalizeBundleIds(selection, { allowEmpty: true });
  const previous = getVitastrongAssignment(entry);
  const previousIds = getVitastrongBundles(entry).map((bundle) => bundle.bundleId);
  if (ids.length === previousIds.length && ids.every((id) => previousIds.includes(id))) return entry;
  const history = Array.isArray(entry.integrazioneHistory) ? [...entry.integrazioneHistory] : [];
  if (previous) history.push({ ...previous });
  if (!ids.length) return { ...entry, integrazioneAssignment: null, integrazioneHistory: history };
  // Reassigning after removal continues the revision sequence, without reusing
  // removed bundle snapshots as if they were still assigned.
  const revisionSource = previous || {
    revision: history.reduce((revision, assignment) => Math.max(revision, Number(assignment?.revision) || 0), 0),
  };
  return { ...entry, integrazioneAssignment: createVitastrongAssignment(ids, actorId, now, revisionSource), integrazioneHistory: history };
}
